import React, { Component } from 'react';
import { connect } from 'react-redux';
import HeaderSimple from './HeaderSimple';
import BrandLogo from './BrandLogo';

export class Header extends Component {
  constructor() {
    super();
  }

  render() {
    const {
      isMobile,
      pageType,
      sponsoredText,
      sponsoredLink,
      sponsoredLogo,
      onMenuClick,
      articleHed,
      standardArticleTracker,
      shareImg,
      shareCopy,
      hedUrl,
    } = this.props;

    const HeaderMenuButton = <div className="header-icon header-icon-menu icon-menu-icon-desktop-nav"/>;
    const HeaderLogo = <BrandLogo mark={isMobile} />;
    const HeaderLogoMark = <BrandLogo mark={true} />;
    const HeaderEmailButton = <div className="share header-icon header-icon-email" />;

    return (
      <div className="header">
        {/* renders on all pages and when scrollTop is 0 on articles */}
        <HeaderSimple
          isMobile={isMobile}
          HeaderLogo={HeaderLogo}
          HeaderMenuButton={HeaderMenuButton}
          standardArticleTracker={standardArticleTracker}
          articleHed={articleHed}
          sponsoredText={sponsoredText}
          sponsoredLogo={sponsoredLogo}
          sponsoredLink={sponsoredLink}
          shareImg={shareImg}
          shareCopy={shareCopy}
          hedUrl={hedUrl}
        />
        </div>
    );
  }
}


const mapStateToProps = ({
  isMobile, pageData, standardArticleTracker,
}) => {
  const { pageType, sponsoredText, sponsoredLogo, sponsoredLink } = pageData;
  const articleHed = '9 Things I Wish I Added to My Wedding Registry';
  const shareImg = sponsoredLogo;
  const shareCopy = 'Spoiler: Skip the champagne flutes and get better small appliances.';
  const hedUrl = null;

  return {
    isMobile,
    articleHed,
    sponsoredLogo,
    sponsoredLink,
    sponsoredText,
    pageType,
    standardArticleTracker,
    shareImg,
    shareCopy,
    hedUrl,
  };
};

const mapDispatchToProps = dispatch => ({
  onMenuClick: () => {
    dispatch({
      type: 'SIDEBAR_TOGGLE',
    });
  },
});

export const HeaderContainer = connect(mapStateToProps, mapDispatchToProps)(Header);

export default HeaderContainer;
